import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';

import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

import { getFilestackClient } from 'lib/clients/filestack/filestackClient';

import Button from '../../Button/Button';
import Modal from '../Modal';

import './SignatureModal.scss';

const PAGE_CHARACTERS = 2300;
const LINE_WIDTH = 180;
const LINE_HEIGHT = 1.5;

const SignatureModal = ({
  showSignatureModal,
  hideSignatureModal,
  signature,
  trimSignature,
  sigPad,
  divToPrint,
  fullFormRef,
  savePDF = () => {},
  x = 10,
  y = 120,
  setLoader
}) => {
  const [drawn, setDrawn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (signature) {
      printDocument();
    }
  }, [signature]);

  const printDocument = async () => {
    setLoader(true);
    const filestackClient = await getFilestackClient(navigate);
    const signatureCurrent = divToPrint.current;
    const fullFormCurrent = fullFormRef.current;
    html2canvas(signatureCurrent, { scale: 0.8 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png', 1.0);
      const raw_hipaaText = fullFormCurrent.innerHTML;
      const hipaaText = raw_hipaaText
        .replace(/&amp;/g, '&')
        .replace(/<[^>/]*>/g, '')
        .replace(/<[^>]*>/g, '\n')
        .replace(/\n\n[\n]*/g, '\n\n');
      const pdf = new jsPDF({ orientation: 'p', unit: 'mm', lineHeight: LINE_HEIGHT });
      const pages = hipaaText.length / PAGE_CHARACTERS;
      pdf.setFontSize(12);
      const wordArray = hipaaText.split(' ');
      const text_page = [];
      let new_text = '';
      for (let i = 0; i < wordArray.length; i++) {
        if (`${new_text} ${wordArray[i]}`.length > PAGE_CHARACTERS) {
          text_page.push(new_text);
          new_text = wordArray[i];
        } else {
          new_text += ` ${wordArray[i]}`;
        }
      }
      if (new_text.length > 0) {
        text_page.push(new_text);
      }
      pdf.text(pdf.splitTextToSize(text_page[0], LINE_WIDTH, LINE_HEIGHT), 10, 10);
      for (let i = 1; i < pages; i++) {
        pdf.addPage();
        pdf.text(pdf.splitTextToSize(text_page[i], LINE_WIDTH, LINE_HEIGHT), 10, 10);
      }
      pdf.addImage(imgData, 'JPEG', x, y);
      const completePdf = pdf.output('blob');
      filestackClient.upload(completePdf).then((result) => {
        if (result?.handle) {
          savePDF(result?.handle);
        }
      });
    });
  };

  const clearSignature = () => {
    sigPad.current.clear();
    setDrawn(false);
  };

  return (
    <Modal
      handleOpen={showSignatureModal}
      handleClose={hideSignatureModal}
      title="Sign here"
      shouldCloseOnOverlayClick={false}
      footer={
        <>
          <Button variant="tertiary" onClick={clearSignature} text="Clear" size="small" />
          <Button
            text="Sign & Continue"
            isDisabled={!drawn}
            onClick={() => {
              trimSignature();
              hideSignatureModal();
            }}
            size="small"
          />
        </>
      }>
      <SignatureCanvas
        penColor="black"
        canvasProps={{ width: 500, height: 200, className: 'SignatureCanvas' }}
        onEnd={() => setDrawn(true)}
        onBegin={() => setDrawn(true)}
        ref={sigPad}
      />
    </Modal>
  );
};

export default SignatureModal;
